var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomBriefcase = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.462 8.947h-4.147V6.874A2.073 2.073 0 0 0 17.242 4.8h-4.148a2.073 2.073 0 0 0-2.073 2.074v2.073H6.874a2.064 2.064 0 0 0-2.064 2.074L4.8 22.426c0 1.145.928 2.073 2.074 2.073h16.588a2.073 2.073 0 0 0 2.074-2.073V11.02a2.073 2.073 0 0 0-2.074-2.074zm-6.22 0h-4.148V6.874h4.148v2.073z",
    fill: "#9A5238",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomBriefcase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-briefcase.cc82664f618f6514502492d300e635be.svg";